const maskSections = document.querySelectorAll('[class*="section--mask"]');

let zIndexCounter = 1; // Je basis z-index

// We lopen van achteren naar voren door de array
for (let i = maskSections.length - 1; i >= 0; i--) {
    maskSections[i].style.zIndex = zIndexCounter;
    zIndexCounter++; // Verhoog de z-index voor de VORIGE sectie
}

const $formSections = $('.section--form');

$formSections.each(function () {
    let $section = $(this),
        $image = $(this).find('img.img-wide');

    if ($image.length < 1) return;

    if ($section.prev('.section').hasClass('section--mask-bottom')) {
        $image.addClass('angle-mask angle-mask--top');
    }
});

const $contentImageSections = $('.section--content-media-blocks');

$contentImageSections.each(function () {
    let $section = $(this),
        $image = $(this).find('img.block__image');

    if ($image.length < 1) return;

    if ($section.prev('.section').hasClass('section--mask-bottom')) {
        $image.addClass('angle-mask angle-mask--top');

        if ($image.closest('.block').hasClass('block--reversed')) {
            $image.addClass('angle-mask--flip');
        }
    }
});

